import { useState } from "react";

export const useMarkers = (deviceType = null, modalFetcher, changeDimFunction, revertDimFunction) => {
    const [markers, setMarkers] = useState([]);
    const [selectedMarker, setSelectedMarker] = useState(null);

    const handleMarkerClick = async (marker) => {
      if (!(marker.payload === 'light' || marker.payload === 'gateway') && deviceType !== "radioCoverage") {
        if (deviceType !== "manage") {
          const metrics = await modalFetcher(marker.id, deviceType);
          setSelectedMarker({
              ...marker,
              metrics : metrics,
          });
        }
        else {
          const metrics = await modalFetcher(marker.id, marker.type);
          setSelectedMarker({
            ...marker, metrics
          });
        }
      }
    };

    const sendDimUpdate = async (dimLevel, marker) => {
        const userConfirmed = window.confirm(
          "Είστε σίγουϝος ότι επιθυμείτε να αλλάξετε το επίπεδο του φωτισμοϝ;"
        );
        
        if (!userConfirmed) {
          return;
        }
      
        try {
          await changeDimFunction(marker[0], dimLevel.toString());
          alert("Το Επίπεδο Φωτισμοϝ άλλαξε");
        } catch (error) {
          console.error("Η αλλαγή Επιπέδου φωτισμοϝ απέτυχε:", error);
          
          alert("Η αλλαγή Επιπέδου φωτισμοϝ απέτυχε. Παϝακαλοϝμε Πϝοσπαθήστε αϝγότεϝα.");
        }
    }

    const revertDimUpdate = async (marker) => {
        const userConfirmed = window.confirm(
          "Είστε σίγουϝος ότι επιθυμείτε να αλλάξετε το επίπεδο του φωτισμοϝ;"
        );
        
        if (!userConfirmed) {
          return;
        }
      
        try {
          await revertDimFunction(marker[0]);

          alert("Πϝαγματοποίηθηκε επαναφοϝά του πϝογϝάμματος.");
        } catch (error) {
          console.error("Η επαναφοϝά Επιπέδου φωτισμοϝ απέτυχε:", error);
          
          alert("Η επαναφορά Επιπέδου φωτισμού απέτυχε. Παρακαλούμε Προσπαθήστε αργότερα.");
        }
    }

    const handleCloseModal = () => {
        setSelectedMarker(null);
    };

    const handleMapClick = (e) => {
        const {lat, lng} = e.latlng;
        setMarkers((current) => [...current, {lat, lng}]);
    };

    return {
        markers,
        setMarkers,
        selectedMarker,
        handleMarkerClick,
        handleCloseModal,
        handleMapClick,
        sendDimUpdate,
        revertDimUpdate,
    };
};